import styles from './sectionTitleWithButton.module.scss';
import CheckMarkIcon from '../../../../../src/assets/images/icons/check-mark.svg';
import { Typography } from '@mui/material';

const SectionTitleWithButton = ({
  title = '',
  completed = false,
  unlocked = false,
  btn = false,
  number = '1',
  btnAction = () => {},
  btnText = 'Edit',
}) => {
  return (
    <div className={styles.container}>
      <div
        className={`${styles.iconNumber} ${unlocked ? styles.unlocked : ''} ${
          unlocked & completed ? styles.completed : ''
        }`}
      >
        {number}
      </div>
      <div
        className={`${styles.titelWithCheckMark} ${
          unlocked ? styles.unlocked : ''
        }`}
      >
        <Typography
          variant="h3"
          color={'primary.main'}
          onClick={(e) => btnAction(e)}
          className={btn ? styles.sectionTitle : styles.sectionTitleNoEvent}
        >
          {title}
        </Typography>
        {completed && (
          <CheckMarkIcon style={{ transform: 'translateY(-2px)' }} />
        )}
      </div>
      {btn && (
        <div className={styles.btnContainer}>
          <div onClick={(e) => btnAction(e)} className={styles.btnText}>
            {btnText}
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionTitleWithButton;
